import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {NGPReport} from '../../../../shared-utilities/models-old/ngp-reports/ngp-report';
import {StockItem} from '../../../../shared-utilities/models-old/datastructures';
import {IHeartbeatErrorLogs} from '../../models/interfaces';
import {doc, Firestore, getDoc} from '@angular/fire/firestore';
import {SharedModalUtils} from '../../../../shared/shared-utils/shared-modal/shared-modal.utils';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../shared-icons/models/icons-colour.enum';

@Component({
  selector: 'app-cell-renderer-freshness',
  templateUrl: './cell-renderer-freshness.component.html',
  styleUrls: ['./cell-renderer-freshness.component.scss'],
  standalone: false,
})
export class CellRendererFreshnessComponent implements ICellRendererAngularComp {
  value: string | number;
  params: ICellRendererParams<NGPReport | StockItem, string | number>;
  type: string;
  currentPage: string;
  types: string[] = [];

  constructor(
    private readonly fs: Firestore,
    private readonly sharedModalUtils: SharedModalUtils,
  ) {
  }

  agInit(params: ICellRendererParams<NGPReport | StockItem, string | number>): void {
    this.params = params;
    this.value = params.value;
    this.type = params.colDef.field as string;
    this.types.push(this.type);
  }

  async onFreshnessClick(): Promise<void> {
    if (this.type !== 'heartbeat') return;

    try {
      const storeId = this.params.data?.storeId;
      if (!storeId) {
        await this.showAlert('Missing storeId', 'Row data has no storeId.');
        return;
      }

      const ref = doc(this.fs, `/observation/stores_data/${storeId}/data/logs/error_logs`);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        await this.showAlert('No Error Logs', 'This store has no error log document.');
        return;
      }

      const data = snap.data() as IHeartbeatErrorLogs;
      await this.showErrorLogPopup(data);
    } catch (err) {
      await this.showAlert('Failed to load logs', String(err), 'Close');
    }
  }

  refresh(): boolean {
    return false;
  }

  /**
   * Shows a simple informational modal.
   */
  private async showAlert(header: string, message: string, buttonText: string = 'OK'): Promise<void> {
    await this.sharedModalUtils.createModal({
      modalTitle: header,
      modalTitleIcon: IconsEnum.alertBox,
      modalTitleIconColor: IconColourEnum.red,
      contextDescription: [message],
      buttonAcceptText: buttonText,
      buttonCloseText: '',
      buttonAccept: true,
      buttonClose: false,
      buttonCloseCross: false,
      cssClass: ['shared-basic-modal-css-smaller'],
    });
  }

  /**
   * Shows heartbeat error log details.
   */
  private async showErrorLogPopup(payload: IHeartbeatErrorLogs): Promise<void> {
    const logLines: string[] = (payload.errorLogs ?? []).flatMap((entry: {text: string}) =>
      entry.text.split(/\n+/).map((line: string) => line.trim()).filter(Boolean),
    );
    const contextDescription: string[] = [];
    if (payload.message) {
      contextDescription.push(payload.message);
    }
    contextDescription.push(...logLines);

    await this.sharedModalUtils.createModal({
      modalTitle: `Status: ${payload.status}`,
      modalTitleIcon: IconsEnum.alertBox,
      modalTitleIconColor: IconColourEnum.red,
      contextDescription: contextDescription.length > 0 ? contextDescription : ['No error log details.'],
      buttonAcceptText: 'Dismiss',
      buttonCloseText: '',
      buttonAccept: true,
      buttonClose: false,
      buttonCloseCross: false,
      cssClass: ['shared-basic-modal-css'],
    });
  }
}
